import { DialogFooter, IDialogStyles } from '@fluentui/react';
import { ReactNode } from 'react';

import { IPDefaultButton, IPDialog, IPPrimaryButton, IPScrollablePane } from 'baseComponents';
import { IPDialogType } from 'baseComponents/Dialog/IPDialog';
import { IPScrollbarVisibility } from 'baseComponents/ScrollablePane/IPScrollablePane';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { useTranslation } from 'react-i18next';

export interface IDialogYesNoProps {
  onYes: () => void;
  onNo: () => void;
  hidden: boolean;
  title: string;
  subText: string;
  yesText?: string;
  noText?: string;
  disableYes?: boolean;
  dialogStyles?: Partial<IDialogStyles>;
  optionalJSX?: JSX.Element;
  optionalJSXGrow?: boolean;
  optionalJSXHeight?: string | number;
  optionalJSXWidth?: string | number;
  children?: ReactNode;
}

const DialogYesNo = (props: IDialogYesNoProps) => {
  const { t } = useTranslation(['translation']);

  const dialogContentProps = {
    type: IPDialogType.normal,
    title: props.title,
    subText: props.subText,
    showCloseButton: true,
  };

  return (
    <IPDialog
      hidden={props.hidden}
      onDismiss={props.onNo}
      dialogContentProps={dialogContentProps}
      styles={props.dialogStyles}
    >
      {props.optionalJSX && !props.optionalJSXGrow && (
        <IPStack>
          <IPStack.Item
            grow
            styles={{
              root: {
                marginTop: 0,
                position: 'relative',
                width: props.optionalJSXWidth,
                height: props.optionalJSXHeight ?? '20vh',
                maxHeight: '80vh',
              },
            }}
          >
            <IPScrollablePane scrollbarVisibility={IPScrollbarVisibility.auto}>{props.optionalJSX}</IPScrollablePane>
          </IPStack.Item>
        </IPStack>
      )}
      {props.optionalJSX && props.optionalJSXGrow === true && (
        <IPStack>
          <IPStack.Item
            grow
            styles={{
              root: {
                marginTop: 0,
                maxHeight: '80vh',
              },
            }}
          >
            {props.optionalJSX}
          </IPStack.Item>
        </IPStack>
      )}
      <DialogFooter>
        <IPPrimaryButton
          disabled={props.disableYes}
          onClick={props.onYes}
          text={props.yesText ?? t('translation:Dialogs.YesNo.Yes')}
        />
        <IPDefaultButton onClick={props.onNo} text={props.noText ?? t('translation:Dialogs.YesNo.No')} />
      </DialogFooter>
    </IPDialog>
  );
};

export default DialogYesNo;
